<div *ngIf="pageCurrent != 0" class="d-flex flex-row justify-content-around" (click)="open()">
  <div class="flag flag-property" [ngClass]="{
          'flag-mexico': ['es_MX', 'es-MX'].includes(currentLang),
          'flag-usa': ['en_US','en-US'].includes(currentLang),
          'flag-france': ['fr_FR','fr-FR'].includes(currentLang),
          'flag-holland': ['du_NL','du-NL'].includes(currentLang),
          'flag-portuguese': ['pt_PT','pt-PT'].includes(currentLang),
          'flag-japanese': ['ja_JP','ja-JP'].includes(currentLang),
          'flag-chinese': ['zh_CN','zh-CN'].includes(currentLang),
          'flag-korean': ['kr_KR','kr-KR'].includes(currentLang)
          }">

  </div>
  <div class="text-singleButton d-flex flex-row fs-20px text-center fw-regular align-items-center mx-3" *ngIf="showTextLenguages">
    <span>{{ globals.languageSelected?.text }}</span>
  </div>
  <div class="d-flex flex-row align-items-center ml-4" [ngClass]="{'marginModal':!showTextLenguages}">
    <i class="fas fa-caret-down fa-1x"></i>
  </div>
</div>
<div *ngIf="pageCurrent == 0" class="d-flex">

  <div  class="d-flex flex-row  am-button-lang border-select flag-margin-mx" [ngClass]="{'border-select': currentLang === 'es_MX'}" (click)="onSelected({id:'es-MX',text:'Español'})">
    <div class="flag-mx-img flag-mexico flag-property"></div>
    <div class="d-flex flex-row text-center align-items-center flag-margin-mx-txt">
      <span>{{ "spanish" | translate }}</span>
    </div>
    <div *ngIf="currentLang === 'es_MX' || currentLang === 'es-MX'" class="d-flex flex-row align-items-center check">
     <img src="../../../../assets/images/check-home.svg" alt="check">
    </div>
  </div>


  <div  class="d-flex flex-row  am-button-lang border-select" [ngClass]="{'border-select': currentLang === 'en_US'}" (click)="onSelected({id:'en-US',text:'English'})">
    <div class="flag-usa flag-usa-img flag-property"></div>
    <div class="d-flex flex-row text-center align-items-center flag-margin ">
      <span>{{ "english" | translate }}</span>
    </div>
    <div *ngIf="currentLang === 'en_US' || currentLang === 'en-US'" class="d-flex flex-row align-items-center check">
     <img src="../../../../assets/images/check-home.svg" alt="check">
    </div>
  </div>

  <div  style="margin-left: 25px;" class="d-flex flex-row justify-content-around am-button-lang" [ngClass]="{'border-select': !otherNotAllowed}" (click)="open()">
    <div class="d-flex flex-row text-center align-items-center mx-2">
      <span>{{ "other" | translate }}...</span>
    </div>
    <div *ngIf="!otherNotAllowed" class="d-flex flex-row align-items-center check">
      <img src="../../../../assets/images/check-home.svg" alt="check">
     </div>
  </div>
</div>
